import { PointIconP } from "../icon";


interface IProps {
    enable: boolean;
    needIcon?: boolean;
    Wrapper?: any;
    prefix?: string;
    suffix?: string;
}

export const DisplayPoints = ({ Wrapper, enable, prefix, suffix, needIcon }: IProps) => {

    if (Wrapper) {
        return <>{enable && <Wrapper>
            {prefix} {needIcon && <PointIconP />} {suffix}
        </Wrapper>}
        </>;
    }
    else {
        return <>{enable && <>
            {prefix} {needIcon && <PointIconP />} {suffix}
        </>}
        </>;
    }


};
